import { configureStore } from '@reduxjs/toolkit'
import recipesReducer from './recipesSlice'
import ingredientsReducer from './ingredientsSlice'
import authReducer from './authSlice'
import pricesReducer from './pricesSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    recipes: recipesReducer,
    ingredients: ingredientsReducer,
    prices: pricesReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
